import BaseStore from './BaseStore'

export class IssueNumberStore extends BaseStore {
  constructor() {
    super()
    this.endpoint = 'issue_numbers'
  }
}

export default new IssueNumberStore()


// WEBPACK FOOTER //
// ./src/stores/IssueNumberStore.js